// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__xK5WU","empty":"ModalGraph_empty__1TCQg"};